import { Action } from '@ngrx/store';
import { IPaymentFoundationTrustee } from '../../../commons';

export enum PaymentFoundationTrusteeActionTypes {
  LoadPaymentFoundationTrusteeState = '[PaymentFoundationTrustee] Load PaymentFoundationTrustee State',
  ProcessPaymentFoundationTrustee = '[PaymentFoundationTrustee] Process PaymentFoundationTrustee State',
  UpdateToCheckIssueFoundationTrustee = '[PaymentFoundationTrustee] Update Status To Foundation Trustee State',
  LoadPaymentFoundationTrusteeStateSuccess = '[PaymentFoundationTrustee] Load PaymentFoundationTrustee State Success',
  LoadProcessedPaymentFoundationTrusteeState = '[PaymentFoundationTrustee] Load Processed PaymentFoundationTrustee State',
  LoadProcessedPaymentFoundationTrusteeStateSuccess = '[PaymentFoundationTrustee] Load Processed PaymentFoundationTrustee State Success',
  LoadPaymentFoundationTrusteeStateFail = '[PaymentFoundationTrustee] Load PaymentFoundationTrustee State Fail',
  PaymentFoundationTrusteeScreenErrorReset = '[PaymentFoundationTrustee] PaymentFoundationTrustee Screen Error Reset'

}

export class LoadPaymentFoundationTrusteeState implements Action {
  readonly type = PaymentFoundationTrusteeActionTypes.LoadPaymentFoundationTrusteeState;
}

export class ProcessPaymentFoundationTrustee implements Action {
  readonly type = PaymentFoundationTrusteeActionTypes.ProcessPaymentFoundationTrustee;
  constructor(public payload: any [] ) {}
}
export class UpdateToCheckIssueFoundationTrustee implements Action {
  readonly type = PaymentFoundationTrusteeActionTypes.UpdateToCheckIssueFoundationTrustee;
  constructor(public payload: any [] ) {}
}

export class LoadPaymentFoundationTrusteeStateSuccess implements Action {
  readonly type = PaymentFoundationTrusteeActionTypes.LoadPaymentFoundationTrusteeStateSuccess;
  constructor(public payload: IPaymentFoundationTrustee [] ) {}
}

export class LoadProcessedPaymentFoundationTrusteeState implements Action {
  readonly type = PaymentFoundationTrusteeActionTypes.LoadProcessedPaymentFoundationTrusteeState;
}

export class LoadProcessedPaymentFoundationTrusteeStateSuccess implements Action {
  readonly type = PaymentFoundationTrusteeActionTypes.LoadProcessedPaymentFoundationTrusteeStateSuccess;
  constructor(public payload: IPaymentFoundationTrustee [] ) {}
}

export class LoadPaymentFoundationTrusteeStateFail implements Action {
  readonly type = PaymentFoundationTrusteeActionTypes.LoadPaymentFoundationTrusteeStateFail;
  constructor(public payload: any) {}
}

export class PaymentFoundationTrusteeScreenErrorReset implements Action {
  readonly type = PaymentFoundationTrusteeActionTypes.PaymentFoundationTrusteeScreenErrorReset;
}

export type PaymentFoundationTrusteeActions = 
  LoadPaymentFoundationTrusteeState
  | ProcessPaymentFoundationTrustee
  | UpdateToCheckIssueFoundationTrustee
  | LoadPaymentFoundationTrusteeStateSuccess
  | LoadProcessedPaymentFoundationTrusteeState
  | LoadProcessedPaymentFoundationTrusteeStateSuccess
  | LoadPaymentFoundationTrusteeStateFail
  | PaymentFoundationTrusteeScreenErrorReset;